@if (showSkeleton()) {
  <output class="nearest-drop-off__loading visually-hidden">
    {{ 'createShipment.serviceStep.pickupDropOff.nearestLocation.loading' | translate }}
  </output>
  <app-nearest-drop-off-skeleton />
} @else if (loading()) {
  <!-- Blank hold before the delayed skeleton paints (avoids flash on fast locator responses). -->
} @else if (errorMessage()) {
  <puro-alert severity="error" data-testid="nearest-drop-off-error">
    {{ errorMessage() }}
  </puro-alert>
} @else if (location(); as loc) {
  <article class="nearest-drop-off" data-testid="nearest-drop-off-card">
    <div class="nearest-drop-off__header">
      <puro-typography variant="h5" component="h3" class="nearest-drop-off__title">
        <span>{{
          'createShipment.serviceStep.pickupDropOff.nearestLocation.toPrefix' | translate
        }}</span>
        <span class="nearest-drop-off__postal">{{ displayPostal() }}</span>
      </puro-typography>

      @if (homeLocatorUrl()) {
        <a
          class="nearest-drop-off__find-other"
          [href]="homeLocatorUrl()"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nearest-drop-off-find-other"
        >
          {{ 'createShipment.serviceStep.pickupDropOff.nearestLocation.findOther' | translate }}
          <span class="visually-hidden">{{
            'createShipment.serviceStep.pickupDropOff.nearestLocation.opensInNewWindow' | translate
          }}</span>
          <puro-icon name="link" size="sm" [animated]="false" aria-hidden="true" />
        </a>
      }
    </div>

    <div class="nearest-drop-off__body">
      <div class="nearest-drop-off__main">
        <div class="nearest-drop-off__details">
          <puro-typography variant="body1" component="p" class="nearest-drop-off__distance-row">
            <span>{{ distanceLabel() }}</span>
            <span aria-hidden="true"> | </span>
            @if (homeLocatorUrl()) {
              <a
                class="nearest-drop-off__view-map"
                [href]="homeLocatorUrl()"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nearest-drop-off-view-map"
              >
                {{ 'createShipment.serviceStep.pickupDropOff.nearestLocation.viewMap' | translate }}
                <span class="visually-hidden">{{
                  'createShipment.serviceStep.pickupDropOff.nearestLocation.opensInNewWindow'
                    | translate
                }}</span>
              </a>
            }
          </puro-typography>

          <puro-typography
            variant="h5-semibold"
            component="p"
            color="secondary"
            class="nearest-drop-off__name"
          >
            {{ loc.locationName }}
          </puro-typography>

          <div class="nearest-drop-off__meta-row">
            <puro-icon
              class="nearest-drop-off__pin-icon"
              name="geo-location-pin-1"
              size="sm"
              [animated]="false"
              aria-hidden="true"
            />
            <puro-typography variant="body1" component="p" class="nearest-drop-off__address">
              @if (addressLines().line1) {
                {{ addressLines().line1 }}
                <br />
              }
              {{ addressLines().line2 }}
            </puro-typography>
          </div>

          @if (loc.phoneNumber) {
            <div class="nearest-drop-off__meta-row">
              <span class="nearest-drop-off__phone-icon-wrap" aria-hidden="true">
                <puro-icon
                  class="nearest-drop-off__phone-icon"
                  name="telephone"
                  size="sm"
                  [animated]="false"
                  aria-hidden="true"
                />
              </span>
              <puro-typography variant="body1" component="p" class="nearest-drop-off__phone">
                {{ loc.phoneNumber }}
              </puro-typography>
            </div>
          }
        </div>

        <div class="nearest-drop-off__services" data-testid="nearest-drop-off-services">
          <puro-typography
            variant="body-bold"
            component="h4"
            class="nearest-drop-off__section-title"
          >
            {{
              'createShipment.serviceStep.pickupDropOff.nearestLocation.availableServices'
                | translate
            }}
          </puro-typography>
          <ul class="nearest-drop-off__service-list">
            @for (key of availableServiceKeys(); track key) {
              <li>{{ key | translate }}</li>
            }
          </ul>
        </div>
      </div>

      <div class="nearest-drop-off__hours" data-testid="nearest-drop-off-hours">
        <puro-typography variant="body-bold" component="h4" class="nearest-drop-off__section-title">
          {{
            'createShipment.serviceStep.pickupDropOff.nearestLocation.hoursOfOperation' | translate
          }}
        </puro-typography>
        <div class="nearest-drop-off__hours-grid">
          <div class="nearest-drop-off__hours-days">
            @for (row of hourRows(); track row.dayLabel) {
              <puro-typography variant="legal" component="p">{{ row.dayLabel }}</puro-typography>
            }
          </div>
          <div class="nearest-drop-off__hours-times">
            @for (row of hourRows(); track row.dayLabel) {
              <puro-typography variant="legal" component="p">{{ row.hoursLabel }}</puro-typography>
            }
          </div>
        </div>
        @if (latestDropOffTime(); as dropOffTime) {
          <puro-typography
            variant="legal-semibold"
            component="p"
            class="nearest-drop-off__latest"
            data-testid="nearest-drop-off-latest"
          >
            {{ 'createShipment.serviceStep.pickupDropOff.nearestLocation.latestDropOff' | translate
            }}{{ dropOffTime }}
          </puro-typography>
        }
      </div>
    </div>
  </article>
}
